import { CircularProgress } from '@material-ui/core';
import { Delete } from '@material-ui/icons';
import React from 'react';

import { IAttachment } from '../../interfaces/domain';

import classes from './Attachments.module.scss';

interface IProps {
  attachments: IAttachment[] | null;
  onDelete?: (attachment: IAttachment) => void;
  uploading?: boolean;
  showTitle?: boolean;
}

const Attachments: React.FC<IProps> = ({
  attachments,
  onDelete,
  uploading,
  showTitle,
}) => {
  const hasAttachments = Boolean(attachments && attachments.length > 0);

  return (
    <div>
      {showTitle && hasAttachments && (
        <p>
          <strong>Lisätyt liitteet</strong>
        </p>
      )}
      {!hasAttachments && !uploading && <p>Ei liitteitä.</p>}
      {hasAttachments &&
        attachments!.map((attachment) => (
          <div key={attachment.id} className={classes.Item}>
            <a href={attachment.link} target="_blank" rel="noopener noreferrer">
              {attachment.name}
            </a>
            {onDelete && (
              <span
                className={classes.Remove}
                onClick={() => onDelete(attachment)}
                title="Poista liite"
              >
                <Delete />
              </span>
            )}
          </div>
        ))}
      {uploading && (
        <div className={classes.Uploading}>
          <CircularProgress size={20} />
          <span>Ladataan liitettä...</span>
        </div>
      )}
    </div>
  );
};

export default Attachments;
